import clsx from "clsx";

import "./style.less";
import type { BadgeProps } from "./types";

export function Badge({ className, children }: BadgeProps) {
  return <div className={clsx("Badge-component", className)}>{children}</div>;
}
